const searchStrip = {
  hotels: "الفنادق", // translated 
  city: "مدينة", // translated 
  checkIn: "تحقق في", // translated 
  checkOut: "الدفع", // translated 
  date: "تاريخ", // translated 
  persons: "الأشخاص", // translated 
  adults: "الكبار", // translated 
  rooms: "غرف", // translated 
  editSearch: "تحرير البحث", // translated 
  newSearch: "بحث جديد", // translated 
  listView: "عرض القائمة", // translated 
  mapView: "عرض الخريطة", // translated 
};




export default searchStrip;
